import Measurer from "../interaction/Measurer";
import TuerDragHandle from "./HeightDragHandle";
import FullHeightDragable from "./FullHeightDragable";
import InterieurDragBox from "./InterieurDragBox";
import {v3} from "oc-threejs/short3";
import Debugs from "oc-threejs/Debugs";
import Helper from "../model/Helper";

export default class Trennwandbox extends FullHeightDragable {

    constructor(vsData) {
        super(vsData);
        this.dragHandles = [Measurer.BOTTOM, Measurer.TOP].map(border => {
            const handle = new TuerDragHandle(this, border);
            this.boxLocalO3.add(handle);
            return handle;
        });
        this.dragBox.position.z = 2;
    }

    createDragBox() {
        this.dragBox = new InterieurDragBox();
        this.dragBox.sizeAdd = v3(0, 0, -10);
        this.add(this.dragBox);
    }

    setChangeable(changeable) {
        this.hoverable = changeable;
        this.draggable = changeable;
        this.tapable = changeable;
        this.dragBox.visible = changeable;
        this.dragHandles.forEach(h => h.visible = changeable);
    }

    onChangeInDragSelectHoverState() {
        this.dragHandles.forEach(handle => handle.onChangeInDragSelectHoverState());
        super.onChangeInDragSelectHoverState();
    }

    onDragBegin() {
        super.onDragBegin();
        this.vsData.isDropped = false;
    }

    onDrop() {
        super.onDrop();
        this.onTap();
        this.vsData.isDropped = true;
    }

    onTap() {
        // delay damit eventuelle Fehler direkt angezeigt werden (tritt auf, wenn die Schranktiefe 42 ist,
        // und eine Kleiderstange vorhanden ist, aber noch keine Front existiert)
        // bei onDrop ist die Schubladenbox nämlich noch nicht im Element eingefügt
        _.delay(()=>this.showDialog(),100);
    }

    showDialog() {
        if (this.vsData.isOrphaned()) {
            return;
        }

        APP.uiHandler.sidebar('trennwandbox', this);

        // const elements = this.vsData.elements;
        //
        // const checkHeight = (index) => (inputs) => {
        //     const elementBreiten = elements.map((element,index)=>Helper.parseFloat(inputs.number('breiteFach'+index)));
        //     inputs.disable(false);
        //     inputs.message('all', '');
        //     APP.model.tryCompile(()=>this.vsData.setElementBreiten(elementBreiten), e=>{
        //         inputs.message('all', I18N(e.i18nKey, ...e.params));
        //         inputs.disable(true);
        //     });
        //     elements.map((element,index)=>inputs.number('breiteFach'+index,Helper.round(element.size.x)));
        // };

        // Für den Moment können wir nur Mittelwände in der Mitte...
        // APP.uiHandler.dialog({
        //     title: I18N('dialogTrennwandboxTitle'),
        //     text: I18N('dialogTrennwandboxText') + ' <div id="msg-all" style="margin-top:2em;color:red"></div>',
        //     inputs: elements.map((element,index)=>({
        //         id: 'breiteFach'+index,
        //         label: I18N('breiteFach'+index),
        //         text: true,
        //         withUnit: true,
        //         disabled: index===this.vsData.elements.length-1,
        //         value: Helper.round(element.size.x),
        //         events: { change: checkHeight(index) }
        //     })),
        //     buttons: [{
        //         style: 'primary',
        //         label: I18N('OK'),
        //         click: checkHeight()
        //     }]
        // });
    }

    // vsUpdate() {
    //     super.vsUpdate();
    //
    //     if (this.isVsChanged('size')) {
    //         Scenes.remove(this.debugBox);
    //
    //         this.debugBox = new THREE.Group();
    //         this.boxLocalO3.add(this.debugBox);
    //
    //         const b = Scenes.box(this.vsData.size,{wireframe:true,color:0xff0000});
    //         b.position.copy(this.vsData.size).multiplyScalar(0.5);
    //         this.debugBox.add(b);
    //
    //         this.vsData.elements.forEach(e=>{
    //             this.debugBox.add(Debugs.box(e.box,0x0000ff,true));
    //             e.konstruktionsboeden.forEach(k=>{
    //                 this.debugBox.add(Debugs.box(k.box,0x00ff00,true));
    //             });
    //             e.interieurs.forEach(i=>{
    //                 const p = v3(e.box.min.x,i.y,e.box.max.z+5);
    //                 this.debugBox.add(Debugs.point(p,0x00ff00,1));
    //             });
    //         });
    //     }
    // }

}
